<template>
  <svg
    :class="[direction, color]"
    xmlns="http://www.w3.org/2000/svg"
    width="11.414"
    height="12.414"
    viewBox="0 0 11.414 12.414"
  >
    <g
      id="Generic_south_chevron"
      data-name="Generic south chevron"
      transform="translate(0.707)"
    >
      <path
        id="Path_1808"
        data-name="Path 1808"
        d="M-586.395,1798.736h-11"
        transform="translate(1803.736 597.395) rotate(90)"
        fill="none"
        stroke="#2d323c"
        stroke-width="2"
      />
      <path
        id="Path_1809"
        data-name="Path 1809"
        d="M-592.4,1805.235l5-5-5-5"
        transform="translate(1805.235 598.395) rotate(90)"
        fill="none"
        stroke="#2d323c"
        stroke-width="2"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'DirectionArrow',
  props: {
    direction: {
      type: String,
      default: 'down',
    },
    color: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
svg {
  transition: all ease 0.3s;
}
.up {
  transform: rotate(180deg);
}
.right {
  transform: rotate(-90deg);
}
.left {
  transform: rotate(90deg);
}
.white {
  path {
    stroke: white;
  }
}
</style>
